import React from 'react';
import { CBadge } from '@coreui/react';

interface IPosition {
  side: string;
}

const PositionTypeBadge = (props: { position: IPosition }) => {
  const { position } = props;
  const sideColorBadge = position.side === 'buy' ? 'success' : 'danger';
  return (
    <CBadge color={sideColorBadge} title={position.side}>
      {position.side.toUpperCase()}
    </CBadge>
  );
};

export default PositionTypeBadge;
